export default {"src":"/_next/static/media/right_filled.9605d006.svg","height":24,"width":24};